import "./SSONotRegistered.css";
import { Divider, Typography } from "@mui/material";
import React, { useEffect } from "react";
import ButtonComponent from "../../Components/ButtonForm/Button";
import { useNavigate } from "react-router-dom";
import { AllRoutes } from "../../Routes/router";
import { DeleteMemberIdFromLocalStorage, SetEncryptedMemberIdToLocalStorage } from "../../Helpers/CommonFunctions/EncryptedMemberIdFunction";
import { decryptV2 } from "../../Helpers/Cryptography/CryptoV2";
import { setSsoFromCurrentDomain } from "../../Redux/Actions";
import { useDispatch, useSelector } from "react-redux";

const SSONotRegistered = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  //@ts-ignore
  const ssoFromCurrentDomain = localStorage.getItem("ssoFromCurrentDomain");

  enum ButtonClickTarget {
    ModalSSONotRegisteredNo,
    ModalSSONotRegisteredYes,
  }

  const onButtonClick = (target: ButtonClickTarget) => {
    switch (target) {
      case ButtonClickTarget.ModalSSONotRegisteredYes:
        //setModalIsOpen(false);
        navigate(AllRoutes.MemberRegistrationForm.link);
        break;
      case ButtonClickTarget.ModalSSONotRegisteredNo:
        DeleteMemberIdFromLocalStorage();
        const ssoFromCurrentDomainDecrypted = decryptV2(ssoFromCurrentDomain);
        localStorage.removeItem("ssoFromCurrentDomain");
        window.location.href = ssoFromCurrentDomainDecrypted === "true" ? process.env.REACT_APP_BASE_URL : "https://work.mahindra.com";
        break;
    }
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);

    if (searchParams.has("error")) {
      //console.info(`searchParams.has("error") : ${searchParams.has("error")}`);
      const error = searchParams.get("error");
      //console.info(`error : ${error}`);
      const errorDecoded = decodeURI(error);
      //console.info(`errorDecoded : ${errorDecoded}`);
      const errorDecrypted = decryptV2(errorDecoded);
      //console.info(`errorDecrypted : ${errorDecrypted}`);
      const errorArr = errorDecrypted.split("||");
      //console.info(`errorArr : ${errorArr}`);
      const errorStr = errorArr?.[0];
      //console.info(`errorStr : ${errorStr}`);
      const errorMemberId = errorArr?.[1];
      //console.info(`errorMemberId : ${errorMemberId}`);

      if (errorMemberId && errorMemberId !== "-1") {
        SetEncryptedMemberIdToLocalStorage(errorMemberId);
      } else if (errorStr === "USER_NOT_REGISTERED") {
        DeleteMemberIdFromLocalStorage();
      }
      searchParams.delete("error");
      dispatch(setSsoFromCurrentDomain(false));
      //setSearchParams(searchParams);
    }
  }, [window.location.search]);

  return (
    <div className="text-center">
      <div className="text-center p-3">
        <img src="images/Logo.png" alt="Pride Logo" />
        <div>
          <Typography variant="h5">
            <Divider>
              <b>Welcome to Mahindra Credit Society</b>
            </Divider>
          </Typography>
        </div>
      </div>
      <div className="body-container">
        <Typography variant="h6">
          You are not registered member of credit society. <br />
          Do you want to register?
        </Typography>
        <div className="p-3">
          <ButtonComponent
            icon={"fa-solid"}
            value={"No"}
            style={{ marginLeft: "10px" }}
            className="btn btn-primary"
            onClick={() => onButtonClick(ButtonClickTarget.ModalSSONotRegisteredNo)}
          />
          <ButtonComponent
            icon={"fa-solid"}
            value={"Yes"}
            style={{ marginLeft: "10px" }}
            className="btn btn-red"
            onClick={() => onButtonClick(ButtonClickTarget.ModalSSONotRegisteredYes)}
          />
        </div>
      </div>
    </div>
  );
};

export default SSONotRegistered;
